import { locateAttr } from "@wx/lib-dom";
import { elementsIds } from "../constants";
export function keyManager(_node, config) {
    if (config.readonly) {
        return;
    }
    const _ = config.locale;
    const { api } = config;
    const dispatch = config.onAction;
    let inFocus = config.inFocus || false;
    let prevFocus;
    function handleHotkey(hotkey, e) {
        switch (hotkey) {
            case "delete": {
                const selected = api.getState().selected;
                if (selected?.length) {
                    const confirm = config.confirmDeletion?.() || Promise.resolve();
                    confirm
                        .then(() => {
                        selected.forEach(id => {
                            api.exec("delete-card", {
                                id,
                            });
                        });
                    })
                        .catch(() => {
                        /* handling cancel */
                    });
                }
                break;
            }
            case "ctrl+d":
                e.preventDefault();
                api.getState().selected?.forEach(id => {
                    const card = api.getCard(id);
                    api.exec("duplicate-card", {
                        id,
                        card: { label: `${_("Duplicate of")} ${card?.label}` },
                    });
                });
                break;
            case "ctrl+z":
                e.preventDefault();
                api.getStores().data.undo();
                break;
            case "ctrl+shift+z":
            case "ctrl+y":
                e.preventDefault();
                api.getStores().data.redo();
                break;
        }
    }
    function handleKeydown(e) {
        if (inFocus) {
            const ctrl = e.ctrlKey || e.metaKey;
            const shift = e.shiftKey;
            const code = e.code.replace("Key", "").toLowerCase();
            const hotkey = `${ctrl ? "ctrl+" : ""}${shift ? "shift+" : ""}${code}`;
            handleHotkey(hotkey, e);
            if (dispatch) {
                dispatch("keydown", { hotkey });
            }
        }
    }
    function handleMousedown(e) {
        const widgetId = locateAttr(e.target, "data-wx-widget");
        inFocus =
            widgetId === elementsIds.kanban || widgetId === elementsIds.toolbar;
        prevFocus = widgetId;
        if (dispatch) {
            dispatch("set-focus", { inFocus });
        }
    }
    function handleFocusOut(e) {
        const widgetId = locateAttr(e.target, "data-wx-widget");
        if (prevFocus === widgetId && !inFocus) {
            inFocus = true;
            prevFocus = elementsIds.kanban;
            if (dispatch) {
                dispatch("set-focus", { inFocus });
            }
        }
    }
    document.addEventListener("keydown", handleKeydown);
    document.addEventListener("mousedown", handleMousedown);
    document.addEventListener("focusin", handleMousedown);
    document.addEventListener("focusout", handleFocusOut);
    return {
        destroy: () => {
            document.removeEventListener("keydown", handleKeydown);
            document.removeEventListener("mousedown", handleMousedown);
            document.removeEventListener("focusin", handleMousedown);
            document.removeEventListener("focusout", handleFocusOut);
        },
    };
}
//# sourceMappingURL=keyManager.js.map